import 'core-js';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AcoreConfigProvider from '@/components/acore-config-provider';
import { init as initMicroApp } from '@/components/micro-app';
import LoadingFullpage from '@/components/loading-fullpage';
import WaterMaker from '@/components/water-maker';
import store from './store';
import Router from './routes/index';
import { injectStore } from './common/report-error';
// 开发 | 测试时使用的小工具
import './exclude-in-production/index';
import './style/global.less';
import './uistyle';
import { stayOnReport } from '@/components/stay-on-report-log';
import NewPandoraConfig from '@/micro-app/context/new-pandora-config';
import { logmainapi, cacheHitLog } from './log';
import './common/shared-runtime';
import { init as yxLogInit } from '@jd/yxlogtag';
import SpacialListConfig from '@/components/SpacialListConfig';
import OrderedPricePath from '@/components/OrderedPricePath';
import WhiteUpload from '@/components/white-upload';
import WhiteList from '@/components/white-list';
try {
  fetch('/remotedatapanel/remoteEntry.js', { mode: 'cors', headers: { 'cache-control': 'no-cache' } }).catch((ex) =>
    console.error(ex)
  );
} catch (ex) {
  console.error(ex);
}

// report error 需要erp信息，所以需要连接store
injectStore(store);

//页面停留时长埋点
stayOnReport(store);

// 初始化微前端库
initMicroApp();

yxLogInit();

ReactDOM.render(
  <AcoreConfigProvider>
    <NewPandoraConfig>
      <Provider store={store}>
        <LoadingFullpage loadDone={logmainapi} cacheHit={cacheHitLog}>
          {/* <NewFeedBack /> */}
          <Router />
        </LoadingFullpage>
        <WaterMaker />
        <SpacialListConfig />
        <OrderedPricePath />
        <WhiteUpload />
        <WhiteList />
      </Provider>
    </NewPandoraConfig>
  </AcoreConfigProvider>,
  document.getElementById('root')
);
